// LOGIN

export const POST_LOGIN = "/user/login";
// export const POST_LOGIN = "/user/login-with-wallet";
export const GET_SETTINGS = "/setting/view/";

// ARTIST SIGNUP
export const REGISTER_ARTIST = "user/register";

// Top Artist USer

export const POST_TOP_ARTIST = "/user/top/artist";

// File
export const POST_FILE = "/file/add";
export const POST_MULTI_FILE = "/file/addMultiple";
export const POST_IPFS_FILE = "/file/ipfs";
export const POST_ART_FILE = "/file/addArt";
// User
export const GET_CURRENT_USER = "/user/profile";
export const PUT_PROFILE = "/user/updateProfile";
export const PUT_PROFILE_IMAGE = "/user/updateProfileImage";
export const GET_USER_BY_WALLET = "/user/userby/";
export const USER_ALL_NFT = "/item/countNftViews";
//change password
export const putChangePassword = "/user/changePassword";
//  Forget Password  user password

export const POST_FORGET = "/user/forgotPassword";
export const POST_OTP = "/user/verifyOTP";
export const POST_RESET = "/user/resetPassword";
// verify email
export const EMAIL_VERIFY = "/user/verify/account";
export const EMAIL_VERIFY_AGAIN = "/user/resend-otp";

// particular user

export const PARTICULAR_USER_API = "/user/getParticularUser";
// Home
export const GET_HOMEPAGE = "/home/";
export const GET_MOSTLY_VIEW = "/home/mostly-viewed-nft";
export const GET_LATEST = "/home/latest-nft";
export const GET_TOP_COLLECTIONS = "/home/top-collections";
export const GET_EXPLORE = "/home/expore-nft";
export const GET_SECONDRY_SALE = "/item/secondrySaleList";
export const POST_FOLLOW = "/user/follow-unfollow";
export const GET_FOLLOW = "/user/followList";

// Collections
export const GET_COLLECTION_NAME_VERIFY = "/collection/byname/";
export const GET_COLLECTION_BYTECODE = "/collection/compile-contract";
// export const GET_COLLECTIONS = "/collection/list";
export const GET_COLLECTIONS = "/collection/getCollections";
// export const GET_COLLECTION2 = "/newCollection/getNewCollections";
export const POST_COLLECTION = "/collection/add";

//NEWCOLLECTION
// export const POST_NEW_COLLECTION = "/newCollection/newCollection";

// export const GET_COLLECTION = "/collection/view/";
export const GET_COLLECTION = "/collection/getCollections";
export const GET_COLLECTION_BY_ADDRESS = "/collection/viewByAddress";
export const PUT_COLLECTION = "/collection/update";
//new collection
export const GET_COLLECTION2 = "/newCollection/getNewCollections";
export const GET_NEW_COLLECTION_BY_ID = "/newCollection/getNewCollectionById/";
export const GET_NEW_COLLECTIONS_BY_EMAIL =
  "/newCollection/getNewCollectionsByEmail";
export const DELETE_NEW_COLLECTION = "/newCollection/deleteNewCollections";
export const POST_NEW_COLLECTION = "/newCollection/newCollection";
export const PUT_NEW_COLLECTION_BY_ID =
  "/newCollection/updateNewCollectionById";
export const GET_ALL_NEW_COLLECTIONS = "/collection/getNewCollections";
export const GET_ALL_NEW_COLLECTIONS_WITH_FILTER =
  "/newCollection/getNewCollectionsWithFilter";
// Categories
export const GET_CATEGORIES = "/category/list";

export const CATEGORIES = "/category";
//  SubsCribe
export const POST_SUBSCRIBE = "/home/subscriptionAdd";
//  News Letter
export const POST_NEWLETTER = "/user/newsletter";
export const SUB_CATEGORIES = "/category/list/subcategories";
// Items
export const LIKE_VIEW = "/item/likeViewCount";
export const NFT_FROM_COLLECTION = "/item/nftFromCollection";
export const GET_ITEMS = "/item/list";
export const POST_ITEM = "/item/user/add"; //king2
export const PUT_ITEM = "/item/user/update";
export const GET_ITEM_BY_TOKEN = "/item/tokenhash/";
export const POST_ITEM_SALE = "/item/user/sale";
export const GET_ACTIVITIES = "/item/activity";
export const POST_ITEM_BUY = "/item/user/buy";
export const POST_FAVOURITE = "/item/user/addfavourite";
export const GET_FAVOURITE = "/item/user/listFavourite";
export const GET_ITEM = "/item/user/view/";
export const GET_SEARCH = "/item/search/";
export const POST_TOGGLE_ITEM_SALE = "/item/user/sale/toggle";
export const POST_UPCOMING = "/item/futureList";
export const GET_ITEM_BY_ID = "/item/viewByItemId/";
export const CURRNET_OWNER = "/item/getCurrentOwnerNft"; //king

/* Bids */
export const POST_BID = "/item/user/addoffer";
export const DELETE_BID = "/item/user/removeoffer";
export const POST_BID_ACTION = "/item/user/actionoffer";
export const GET_BIDS = "/item/user/offers";

// Faq
export const GET_FAQS = "/faq/list";

// Content Pages
export const GET_CONTENT_PAGE = "/page/list";

// Get Images

export const GET_IMAGES = "/setting/list/home/image";

// Contact Us
export const POST_CONTACT_US = "/admin/contact-us";

//  Notifications
export const GET_ART_NOTIFICATION = "/notification/user/getUserNotification";
export const UPDATE_GET_ART_NOTIFICATION =
  "/notification/user/updateArtNotification";
export const POST_NOTIFICATION_API = "notification/admin/postNotification";
export const SEND_NEWSLETTER_EMAIL_API = "/newsLetter/addMail";
export const VERIFY_NEWSLETTER_EMAIL_API = "/newsLetter/verifyMail";
//old
export const GET_NOTIFICATIONS = "/item/user/notifications";
export const PUT_NOTIFICATIONS = "/item/user/readNotification";

//request for verification
export const REQUEST_FOR_VARIFICATION = "/user/verificationProfileRequest";
export const REQUEST_FOR_COLLECTOIN_VARIFICATION =
  "/collection/verificationCollectionRequest";

//blogs
export const GET_BLOGS = "/blog/list";
export const GET_BLOGS_BYID = "/blog/view/";
export const REPORT_ABUSE = "/item/user/reports";

// art page
export const POST_ART = "/art/addArt";
export const GET_ART_BY_USER_ID = "/art/getArtByUserId/";
export const GET_ALL_MUSEUMS = "/user/getAllMuseum";
export const GET_TOP_MUSEUMS = "/user/getTopMuseums";
export const GET_TOP_ARTIST = "/user/getTopArtist";
export const GET_ALL_ARTIST_URL = "/user/getAllArtist";

// owner

export const GET_OWNER = "/owner/getParticularOwner/";
export const ADD_OWNER = "/owner/addOwner";
export const UPDATE_OWNER = "/owner/updateOwner/";
export const GET_ALL_OWNER = "/owner/getAllOwner/";
export const GET_VIEW_COUNT = "/owner/countView/";

// sell item
export const GET_SELL_ITEM = "/sellItems/getParticularSellItem/";
export const ADD_SELL_ITEM = "/sellItems/addSellItem/";
export const GET_ALL_SELL_ITEM = "/sellItems/getAllSellItem/";
export const SELL_ITEM_FROM_COLLECTION_ID =
  "/sellItems/sellItemsFromCollectionId/";
export const LIKE_VIEW_SELLITEM = "/sellItems/likeViewCount";
export const UPDATE_SELLITEM = "/sellItems/updateSellItem";
export const ALL_SELL_ITEM_FROM_COLLECTION =
  "/sellItems/allSellItemsFromCollectionID";
export const ALL_SELL_ITEM_NFT_COUNT = "/sellItems/countView";
export const ALL_SELL_ITEM_CURRENT_OWNER_URL =
  "/sellItems/getAllSellItemFromCurrentOwner"; ///king
export const TOP_SELL_ITEM_URL = "/sellItems/getTopSellItems";
export const TRENDING_ARTWORK_URL = "/sellItems/trendingArtWork";
export const GET_TOP_SALES_OWNER_URL = "/owner/getTopSales";
export const RECENT_LISTING_URL = "/sellItems/getRecentListing";
export const EXPLORE_LISTING_URL = "/sellItems/exploreTrendingArtWork";

// transaction
export const GET_TRANSACTION = "/transaction/getParticularTransaction/";
export const ADD_TRANSACTION = "/transaction/addTransaction/";
export const ADD_PHYSICAL_TRANSACTION = "/physicalTransaction/add/";
export const GET_ALL_TRANSACTION = "/transaction/getAllTransactions/";
export const GET_ALL_TRANSACTION_FROM_USERID =
  "/transaction/getAllTransactionFromUserId/";
export const GET_USER_EARNING_FROM_USERID = "/transaction/getUserEarning/";

/// referrals

export const GET_USER_REFERRALS_URL = "/referral/getUserReferrals/";
export const SEND_REFERRAL_MAIL_URL = "/referral/sendReferralMail/";
export const GET_USER_REDEEM_URL = "/referral/getUserRedeems/";

// print
export const ADD_PRINT_REQUEST = "/printing_partner_panel/addPrintingRequest/";
export const GET_PRINTER_PRODUCT =
  "/printing_partner_panel/getPrintersFromProduct/";
export const GET_PRINT_REQUESTS_URL =
  "/printing_partner_panel/getPrintRequestsFromUserId/";

// print trans
export const ADD_PRINT_TRANS_URL = "/printing_partner_panel/addPrintTrans/";
export const ADD_ARTWORK_FORM_URL =
  "/printing_partner_panel/createPrintArtWorkForm/";
export const GET_ARTWORK_FORM_URL =
  "/printing_partner_panel/getPrintArtWorkForm/";
export const GET_PRINT_REQUEST_FORM_OWNER_URL =
  "/printing_partner_panel/getPrintRequestsFromOwnerId/";
// polygon
export const GET_POLYGON_USER_QR = "/user/login-with-polygon/";
export const POLYGON_AUTH_UPDATE_URL = "/user/updatePolygonAuth/";
export const PRINTER_LIST_URL = "/printing_partner_panel/getPrinterList/";
export const GET_PRINTER_BY_COUNTRY_URL = "/printing_partner_panel/getPrinterByCountry";
export const PAPER_CANVAS_SIZE_URL =
  "/printing_partner_panel/getPrinterCanvasPaperSize/";

export const GET_CHECK_INTENT_URL = "/sellItems/create-payment-intent/";
export const WITHDRAW_REQUEST_SELLER_URL =
  "/printing_partner_panel/sellerWithdrawRequest/";
export const PRINT_REQUEST_TRANS_URL =
  "/printing_partner_panel/getSellerWithdrawRequest/";
export const POST_CUSTOM_ART_URL = "/customArtWork/postCustomArt/";
export const GET_CUSTOM_ART_LIST_URL = "/customArtWork/CustomArtList/";
export const VERIFY_DEALER_CODE_URL = "/printing_partner_panel/dealerCode/";
export const GET_PAYMENT_INTENT_URL = "/sellItems/pay/";

// Physical Art URLs

export const ADD_PHYSICAL_ART = "/sellItems/addPhysicalArt";

export const GET_PHYSICAL_ART_BY_ID = "/physicalSellItems/";

export const GET_PHYSICAL_ART_BY_SELL_ITEM_ID =
  "/physicalSellItems/getPhysicalArtBySellItemId/";

export const GET_PHYSICAL_ART_BY_USER_ID = "/physicalSellItems/user/";
export const LIKE_VIEW_PHYSICAL = "/physicalSellItems/likeViewCount";
export const ADD_PHYSICAL_SELLITEM = "/physicalSellItems/addPhysicalSellItem";

export const GET_EXPLORE_PHYSICAL_ART =
  "/physicalSellItems/exploreTrendingPhysicalArt";


export const FETCH_ALL_PRINTERS = "/printing_partner_panel/getAllPrinterCountrys/";